//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const wordText_en = `along
food
keep
sat
though
always
does
full
letter
second
today
anything
dog
funny
longer
set
took
around
gave
love
seven
town
ask
door
goes
might
show
try
ate
dress
green
money
sing
turn
bed
early
grow
myself
sister
walk
brown
eight
hat
now
sit
warm
buy
every
happy
six
wash
car
eyes
hard
off
sleep
water`;

export default wordText_en;